import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { Divider } from '@material-ui/core';
import PropTypes from 'prop-types';
import { GetEmptyValue } from 'components';

const ViewPCD = ({ completionDates, multiPhase }) => (
  <>
    <FormViewContent
      primaryText="Anticipated Primary Completion Date"
      name="anticipatedPrimaryComplDate"
      secondaryText={(
        <GetEmptyValue value={completionDates && completionDates.anticipatedPrimaryComplDate} />
      )}
    />
    <Divider />
    <FormViewContent
      primaryText="Primary Completion Date"
      name="actualPrimaryComplDate"
      secondaryText={(
        <GetEmptyValue
          value={completionDates && completionDates.actualPrimaryComplDate}
        />
      )}
    />
    {
      multiPhase && (
        <>
          <Divider />
          <FormViewContent
            primaryText={<>Subsequent Phase Activation Date<br /> (For Multi-Phase Trials)</>}
            name="phaseTransitionDate"
            secondaryText={(
              <GetEmptyValue
                value={completionDates && completionDates.phaseTransitionDate}
              />
            )}
          />
        </> 
      )
    }
  </>
);

ViewPCD.propTypes = {
  completionDates: PropTypes.oneOfType([PropTypes.object])
};

ViewPCD.defaultProps = {
  completionDates: null
};

export default ViewPCD;
